import httpService from './http.service';

const updateZone = (zone) => httpService
  .post('/zone', zone)
  .then(({ data }) => data)
  .catch((err) => Promise.reject(err.response));

const updateFavoriteZone = (zoneId, favorite, type) => httpService
  .put('/zone/favorite?zoneId='+zoneId+'&favorite='+favorite+'&type='+type)
  .then(({ data }) => data)
  .catch((err) => Promise.reject(err.response));

export default {
  updateZone,
  updateFavoriteZone
};
